<div class="stellar-background"></div>
<div class="stars-overlay"></div>

<div class="global-controls">
    <div class="control-group">
        <label for="lang-select">{{ t.languageLabel }}:</label>
        <select id="lang-select" class="futuristic-select-small"
            (change)="currentLang = $event.target.value; showTab(activeTab)">
            <option value="es" [selected]="currentLang === 'es'">ES 🇪🇸</option>
            <option value="en" [selected]="currentLang === 'en'">EN 🇺🇸</option>
            <option value="pt" [selected]="currentLang === 'pt'">PT 🇧🇷</option>
        </select>
    </div>
    <div class="control-group">
        <label for="country-select">{{ t.regionLabel }}:</label>
        <select id="country-select" class="futuristic-select-small" (change)="setRegion($event)">
            <option *ngFor="let country of countries" [value]="country.code"
                [selected]="country.code === selectedCountry.code">
                {{ country.flag }} {{ country.name }}
            </option>
        </select>
    </div>
</div>

<div class="main-container">
    <header class="main-header">
        <h1 class="title">{{ t.mainTitle }}</h1>

        <div class="ngcloud-logo-container">
            <svg viewBox="0 0 800 800" xmlns="http://www.w3.org/2000/svg"
                class="ngcloud-logo">
                <defs>
                    <radialGradient id="centralEnergy" cx="50%" cy="50%" r="50%">
                        <stop offset="0%" stop-color="#ffffff" />
                        <stop offset="20%" stop-color="#00f2ff" />
                        <stop offset="60%" stop-color="#e010ff" />
                        <stop offset="100%" stop-color="transparent" />
                    </radialGradient>

                    <filter id="neonGlow" x="-50%" y="-50%" width="200%" height="200%">
                        <feGaussianBlur stdDeviation="4" result="blur" />
                        <feComposite in="SourceGraphic" in2="blur" operator="over" />
                    </filter>
                </defs>

                <g transform="translate(400,400)">
                    <circle r="220" fill="url(#centralEnergy)" opacity="0.4">
                        <animate attributeName="opacity" values="0.3;0.6;0.3" dur="4s" repeatCount="indefinite" />
                    </circle>

                    <g>
                        <circle r="340" fill="none" stroke="#00f2ff" stroke-width="1" stroke-dasharray="2, 10"
                            opacity="0.3" />
                        <circle r="330" fill="none" stroke="#e010ff" stroke-width="8" stroke-dasharray="1, 40"
                            opacity="0.6" />
                        <animateTransform attributeName="transform" type="rotate" from="0" to="360" dur="80s"
                            repeatCount="indefinite" />
                    </g>

                    <g>
                        <circle r="290" fill="none" stroke="#00f2ff" stroke-width="15" stroke-dasharray="10, 160"
                            opacity="0.5" />
                        <circle r="290" fill="none" stroke="#ffffff" stroke-width="2" stroke-dasharray="5, 5"
                            opacity="0.2" />
                        <animateTransform attributeName="transform" type="rotate" from="360" to="0" dur="40s"
                            repeatCount="indefinite" />
                    </g>

                    <g opacity="0.8" filter="url(#neonGlow)">
                        <path d="M-250 0 A 250 250 0 0 1 250 0" fill="none" stroke="#00f2ff" stroke-width="2"
                            stroke-dasharray="50, 20, 10, 20" />
                        <path d="M-250 0 A 250 250 0 0 0 250 0" fill="none" stroke="#e010ff" stroke-width="2"
                            stroke-dasharray="50, 20, 10, 20" />
                        <animateTransform attributeName="transform" type="rotate" from="0" to="360" dur="20s"
                            repeatCount="indefinite" />
                    </g>

                    <g stroke="#ffffff" stroke-width="0.5" opacity="0.3">
                        <line x1="120" y1="0" x2="300" y2="0" />
                        <line x1="-120" y1="0" x2="-300" y2="0" />
                        <line x1="0" y1="120" x2="0" y2="300" />
                        <line x1="0" y1="-120" x2="0" y2="-300" />
                        <animateTransform attributeName="transform" type="rotate" from="0" to="360" dur="10s"
                            repeatCount="indefinite" />
                    </g>

                    <circle r="110" fill="url(#centralEnergy)" filter="url(#neonGlow)">
                        <animate attributeName="r" values="105;115;105" dur="3s" repeatCount="indefinite" />
                    </circle>

                    <text x="0" y="22" font-family="'Orbitron', sans-serif" font-weight="900" font-size="42"
                        fill="#ffffff" text-anchor="middle" text-transform="uppercase" letter-spacing="4"
                        style="filter: drop-shadow(0 0 12px #00f2ff);">
                        NGCLOUD
                        <animate attributeName="opacity" values="0.9;1;0.9" dur="2s" repeatCount="indefinite" />
                    </text>
                </g>
            </svg>
        </div>

        <p class="subtitle">{{ t.subtitle }}</p>
    </header>

    <nav class="futuristic-tabs">
        <button class="tab-button" [class.active-tab]="activeTab === 'modulos-videos'"
            (click)="showTab('modulos-videos')">
            <span>{{ t.tabModules }}</span>
        </button>
        <button class="tab-button" [class.active-tab]="activeTab === 'cotizaciones'" (click)="showTab('cotizaciones')">
            <span>{{ t.tabQuotes }}</span>
        </button>
        <button class="tab-button" [class.active-tab]="activeTab === 'calculadora'" (click)="showTab('calculadora')">
            <span>{{ t.tabCalculator }}</span>
        </button>
        <button class="tab-button" [class.active-tab]="activeTab === 'graficos'" (click)="showTab('graficos')">
            <span>{{ t.tabCharts }}</span>
        </button>
        <button class="tab-button" [class.active-tab]="activeTab === 'about'" (click)="showTab('about')">
            <span>{{ t.tabAbout }}</span>
        </button>
    </nav>

    <div class="content-container">

        <div id="modulos-videos" class="tab-content" [hidden]="activeTab !== 'modulos-videos'">
            <div class="glass-panel">
                <h2 class="section-title">{{ t.tabModules }}</h2>

                <h3 class="module-title">{{ t.platformTitle }}</h3>
                <p class="module-text">{{ t.platformDesc }}</p>

                <div class="module-section">
                    <h3 class="module-title">{{ t.modQuoteTitle }}</h3>
                    <p class="module-text">{{ t.modQuoteDesc }}</p>
                    <ul class="module-list">
                        <li><strong>{{ t.modQuoteListTitle1 }}</strong> {{ t.modQuoteListDesc1 }}</li>
                        <li><strong>{{ t.modQuoteListTitle2 }}</strong> {{ t.modQuoteListDesc2 }}</li>
                        <li><strong>{{ t.modQuoteListTitle3 }}</strong> {{ t.modQuoteListDesc3 }}</li>
                        <li><strong>{{ t.modQuoteListTitle4 }}</strong> {{ t.modQuoteListDesc4 }}</li>
                        <li><strong>{{ t.modQuoteListTitle5 }}</strong> {{ t.modQuoteListDesc5 }}</li>
                        <li><strong>{{ t.modQuoteListTitle6 }}</strong> {{ t.modQuoteListDesc6 }}</li>
                        <li><strong>{{ t.modQuoteListTitle7 }}</strong> {{ t.modQuoteListDesc7 }}</li>
                    </ul>
                </div>

                <div class="module-section">
                    <h3 class="module-title">{{ t.modIncidentTitle }}</h3>
                    <p class="module-text">{{ t.modIncidentDesc }}</p>
                    <ul class="module-list">
                        <li><strong>{{ t.modIncidentListTitle1 }}</strong> {{ t.modIncidentListDesc1 }}</li>
                        <li><strong>{{ t.modIncidentListTitle2 }}</strong> {{ t.modIncidentListDesc2 }}</li>
                        <li><strong>{{ t.modIncidentListTitle3 }}</strong> {{ t.modIncidentListDesc3 }}</li>
                        <li><strong>{{ t.modIncidentListTitle4 }}</strong> {{ t.modIncidentListDesc4 }}</li>
                        <li><strong>{{ t.modIncidentListTitle5 }}</strong> {{ t.modIncidentListDesc5 }}</li>
                        <li><strong>{{ t.modIncidentListTitle6 }}</strong> {{ t.modIncidentListDesc6 }}</li>
                        <li><strong>{{ t.modIncidentListTitle7 }}</strong> {{ t.modIncidentListDesc7 }}</li>
                    </ul>
                    <h4 class="module-subtitle">{{ t.keyBenefits }}</h4>
                    <ul class="module-list">
                        <li><strong>{{ t.modIncidentBenefitTitle1 }}</strong> {{ t.modIncidentBenefitDesc1 }}</li>
                        <li><strong>{{ t.modIncidentBenefitTitle2 }}</strong> {{ t.modIncidentBenefitDesc2 }}</li>
                        <li><strong>{{ t.modIncidentBenefitTitle3 }}</strong> {{ t.modIncidentBenefitDesc3 }}</li>
                        <li><strong>{{ t.modIncidentBenefitTitle4 }}</strong> {{ t.modIncidentBenefitDesc4 }}</li>
                        <li><strong>{{ t.modIncidentBenefitTitle5 }}</strong> {{ t.modIncidentBenefitDesc5 }}</li>
                    </ul>
                </div>

                <div class="module-section">
                    <h3 class="module-title">{{ t.modProblemTitle }}</h3>
                    <p class="module-text">{{ t.modProblemDesc }}</p>
                    <ul class="module-list">
                        <li><strong>{{ t.modProblemListTitle1 }}</strong> {{ t.modProblemListDesc1 }}</li>
                        <li><strong>{{ t.modProblemListTitle2 }}</strong> {{ t.modProblemListDesc2 }}</li>
                        <li><strong>{{ t.modProblemListTitle3 }}</strong> {{ t.modProblemListDesc3 }}</li>
                        <li><strong>{{ t.modProblemListTitle4 }}</strong> {{ t.modProblemListDesc4 }}</li>
                        <li><strong>{{ t.modProblemListTitle5 }}</strong> {{ t.modProblemListDesc5 }}</li>
                        <li><strong>{{ t.modProblemListTitle6 }}</strong> {{ t.modProblemListDesc6 }}</li>
                    </ul>
                    <p class="module-text">{{ t.modProblemFooter }}</p>
                </div>

                <div class="module-section">
                    <h3 class="module-title">{{ t.modInventoryTitle }}</h3>
                    <p class="module-text">{{ t.modInventoryDesc }}</p>
                    <ul class="module-list">
                        <li><strong>{{ t.modInventoryListTitle1 }}</strong> {{ t.modInventoryListDesc1 }}</li>
                        <li><strong>{{ t.modInventoryListTitle2 }}</strong> {{ t.modInventoryListDesc2 }}</li>
                        <li><strong>{{ t.modInventoryListTitle3 }}</strong> {{ t.modInventoryListDesc3 }}</li>
                        <li><strong>{{ t.modInventoryListTitle4 }}</strong> {{ t.modInventoryListDesc4 }}</li>
                        <li><strong>{{ t.modInventoryListTitle5 }}</strong> {{ t.modInventoryListDesc5 }}</li>
                        <li><strong>{{ t.modInventoryListTitle6 }}</strong> {{ t.modInventoryListDesc6 }}</li>
                    </ul>
                    <p class="module-text">{{ t.modInventoryFooter }}</p>
                </div>

                <div class="module-section">
                    <h3 class="module-title">{{ t.modTaskTitle }}</h3>
                    <p class="module-text">{{ t.modTaskDesc }}</p>
                    <ul class="module-list">
                        <li><strong>{{ t.modTaskListTitle1 }}</strong> {{ t.modTaskListDesc1 }}</li>
                        <li><strong>{{ t.modTaskListTitle2 }}</strong> {{ t.modTaskListDesc2 }}</li>
                        <li><strong>{{ t.modTaskListTitle3 }}</strong> {{ t.modTaskListDesc3 }}</li>
                        <li><strong>{{ t.modTaskListTitle4 }}</strong> {{ t.modTaskListDesc4 }}</li>
                        <li><strong>{{ t.modTaskListTitle5 }}</strong> {{ t.modTaskListDesc5 }}</li>
                        <li><strong>{{ t.modTaskListTitle6 }}</strong> {{ t.modTaskListDesc6 }}</li>
                    </ul>
                    <p class="module-text">{{ t.modTaskFooter }}</p>
                </div>

                <div class="module-section">
                    <h3 class="module-title">{{ t.modGeminiTitle }}</h3>
                    <p class="module-text">{{ t.modGeminiIntro }}</p>
                    <p class="module-text">{{ t.modGeminiDesc }}</p>
                    <p class="module-text">{{ t.modGeminiCapabilities }}</p>
                    <ul class="module-list">
                        <li><strong>{{ t.modGeminiListTitle1 }}</strong> {{ t.modGeminiListDesc1 }}</li>
                        <li><strong>{{ t.modGeminiListTitle2 }}</strong> {{ t.modGeminiListDesc2 }}</li>
                        <li><strong>{{ t.modGeminiListTitle3 }}</strong> {{ t.modGeminiListDesc3 }}</li>
                        <li><strong>{{ t.modGeminiListTitle4 }}</strong> {{ t.modGeminiListDesc4 }}</li>
                    </ul>
                    <p class="module-text">{{ t.alsoOffers }}</p>
                    <ul class="module-list">
                        <li>{{ t.offer1 }}</li>
                        <li>{{ t.offer2 }}</li>
                        <li>{{ t.offer3 }}</li>
                    </ul>
                    <p class="module-text">{{ t.businessAdapt }}</p>
                    <p class="module-text">{{ t.contactPrompt }}
                        <a href="mailto:soporte@ng-cloud.cl" class="link">soporte@ng-cloud.cl</a>
                    </p>
                    <p class="module-text">{{ t.elevateProductivity }}</p>
                </div>

                <div class="module-section">
                    <h3 class="module-title">{{ t.promoVideosTitle }}</h3>
                    <div class="videos-grid">
                        <div class="video-container">
                            <iframe src="https://www.youtube.com/embed/LKnexzOMKlg?si=AK0XRt0Bb6s1xvaF" frameborder="0"
                                allowfullscreen></iframe>
                        </div>
                        <div class="video-container">
                            <iframe src="https://www.youtube.com/embed/f6c1oiBW1wY?si=SAHICCsgimtCk_9u" frameborder="0"
                                allowfullscreen></iframe>
                        </div>
                        <div class="video-container">
                            <iframe src="https://www.youtube.com/embed/yYGL6iQ4bqM" frameborder="0"
                                allowfullscreen></iframe>
                        </div>
                        <div class="video-container">
                            <iframe src="https://www.youtube.com/embed/cdH8K7CwXh8" frameborder="0"
                                allowfullscreen></iframe>
                        </div>
                        <div class="video-container">
                            <iframe src="https://www.youtube.com/embed/4CJX4Acqr7A" frameborder="0"
                                allowfullscreen></iframe>
                        </div>
                        <div class="video-container">
                            <iframe src="https://www.youtube.com/embed/IYGzEcfpY44" frameborder="0"
                                allowfullscreen></iframe>
                        </div>
                        <div class="video-container">
                            <iframe src="https://www.youtube.com/embed/IXwDGb6dCHI" frameborder="0"
                                allowfullscreen></iframe>
                        </div>
                        <div class="video-container">
                            <iframe src="https://www.youtube.com/embed/mley6mu4ID8" frameborder="0"
                                allowfullscreen></iframe>
                        </div>
                        <div class="video-container">
                            <iframe src="https://www.youtube.com/embed/HIf4nKrkBaI" frameborder="0"
                                allowfullscreen></iframe>
                        </div>
                        <div class="video-container">
                            <iframe src="https://www.youtube.com/embed/f6c1oiBW1wY" frameborder="0"
                                allowfullscreen></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="cotizaciones" class="tab-content" [hidden]="activeTab !== 'cotizaciones'">
            <div class="glass-panel">
                <h2 class="section-title">{{ t.costDetailsTitle }}</h2>
                <div class="table-container">
                    <table id="tabla-cotizaciones" class="futuristic-table">
                        <thead></thead>
                        <tbody></tbody>
                    </table>
                </div>
            </div>
        </div>

        <div id="graficos" class="tab-content" [hidden]="activeTab !== 'graficos'">
            <div class="glass-panel">
                <h2 class="section-title">{{ t.priceComparisonTitle }}</h2>
                <div class="chart-container">
                    <canvas id="priceComparisonChart"></canvas>
                </div>
                <div id="plan-buttons" class="plan-buttons-container"></div>
                <div class="plan-details-card">
                    <h3 id="plan-name" class="plan-name-display">{{ t.selectPlan }}</h3>
                    <p id="plan-price" class="plan-price-display">--</p>
                </div>
            </div>
        </div>

        <div id="calculadora" class="tab-content" [hidden]="activeTab !== 'calculadora'">
            <div class="glass-panel">
                <h2 class="section-title">{{ t.planRecommenderTitle }}</h2>
                <p class="section-subtitle">{{ t.planRecommenderSubtitle }}</p>
                <div class="calculator-input-group">
                    <input type="number" id="user-input" [placeholder]="t.totalUsersPlaceholder"
                        class="futuristic-input">
                    <button (click)="calculatePlan()" class="button-primary">
                        <span>{{ t.calculatingPlan }}</span>
                    </button>
                </div>

                <div id="result-output" class="result-card" [hidden]="!recommendationResult">
                    <h3 id="result-text" class="result-title"></h3>
                    <ul class="result-list">
                        <li><strong>{{ t.modulesCost }}</strong> <span id="ngcloud-cost"></span></li>
                        <li><strong>{{ t.machineCost }}</strong> <span id="machine-cost-range"></span></li>
                        <li><strong>{{ t.storageCost }}</strong> <span id="storage-cost"></span></li>
                        <li><strong>{{ t.geminiCost }}</strong> <span id="gemini-cost-rec"></span></li>
                        <hr class="divider">
                        <li><strong>{{ t.subtotalNet }}</strong> <span id="total-cost-range"></span></li>
                        <li id="iva-label-row">
                            <strong id="iva-label">{{ t.ivaLabel }}:</strong>
                            <span id="iva-cost-range"></span>
                        </li>
                        <hr class="divider total-divider">
                        <li class="final-total">
                            <strong>{{ t.finalTotal }}:</strong>
                            <span id="final-total-cost-range"></span>
                        </li>
                    </ul>
                    <div class="included-modules">
                        <h4 class="included-modules-title">{{ t.includedModules }}</h4>
                        <ul id="module-list" class="included-modules-list"></ul>
                    </div>
                    <div class="external-links">
                        <p>{{ t.officialCalcLink }}</p>
                        <p><a href="https://azure.microsoft.com/es-es/pricing/calculator/" target="_blank"
                                class="link">{{ t.calcAzure }}</a></p>
                        <p><a href="https://calculator.aws/" target="_blank" class="link">{{ t.calcAws }}</a></p>
                        <p class="disclaimer">{{ t.calcDisclaimer }}</p>
                    </div>
                </div>

                <hr class="section-divider">

                <h2 class="section-title">{{ t.customCalculatorTitle }}</h2>
                <p class="section-subtitle">{{ t.customCalculatorSubtitle }}</p>

                <div class="calculator-form-section">
                    <h3 class="form-title">{{ t.step1Title }}</h3>
                    <p class="form-description">{{ t.step1Subtitle }}</p>
                    <select id="plan-select" class="futuristic-select"></select>
                </div>

                <div class="calculator-form-section">
                    <h3 class="form-title">{{ t.step2Title }}</h3>
                    <p class="form-description">{{ t.step2Subtitle }}</p>
                    <select id="machine-select" class="futuristic-select"></select>
                </div>

                <div class="calculator-form-section">
                    <h3 class="form-title">{{ t.step3Title }}</h3>
                    <p class="form-description">{{ t.step3Subtitle }}</p>
                    <div id="modulos-list" class="modules-grid"></div>
                </div>

                <div class="calculator-form-section">
                    <h3 class="form-title">{{ t.step4Title }}</h3>
                    <p class="form-description">{{ t.step4Subtitle }}</p>
                    <select id="storage-select" class="futuristic-select"></select>
                </div>

                <div class="calculator-form-section">
                    <div class="form-title-wrapper">
                        <h3 class="form-title">{{ t.step5Title }}</h3>
                        <label class="checkbox-label futuristic-checkbox-label">
                            <input type="checkbox" id="gemini-enable-checkbox" (change)="toggleGeminiSection()"
                                class="checkbox-input">
                            <span class="checkbox-custom-squire"></span>
                            <span>{{ t.step5Enable }}</span>
                        </label>
                    </div>
                    <p class="form-description">{{ t.step5Subtitle }}</p>
                    <div id="gemini-options-container">
                        <select id="gemini-select" class="futuristic-select"></select>
                    </div>
                </div>

                <div class="cost-summary-card">
                    <h3 class="summary-title">{{ t.costSummaryTitle }}</h3>
                    <div class="summary-details">
                        <div class="summary-row">
                            <span>{{ t.machineCost }}</span>
                            <span id="machine-cost" class="summary-value">--</span>
                        </div>
                        <div class="summary-row">
                            <span>{{ t.modulesCost }}</span>
                            <span id="modules-cost" class="summary-value">--</span>
                        </div>
                        <div class="summary-row">
                            <span>{{ t.storageCost }}</span>
                            <span id="storage-cost-calc" class="summary-value">--</span>
                        </div>
                        <div class="summary-row">
                            <span>{{ t.geminiCost }}</span>
                            <span id="gemini-cost-calc" class="summary-value">--</span>
                        </div>
                        <hr class="divider">
                        <div class="summary-row subtotal">
                            <span>{{ t.subtotalNet }}</span>
                            <span id="subtotal-cost" class="summary-value-accent">--</span>
                        </div>
                        <div class="summary-row" id="iva-label-calc-row">
                            <span id="iva-label-calc">{{ t.ivaLabel }}:</span>
                            <span id="iva-cost" class="summary-value">--</span>
                        </div>
                        <hr class="divider total-divider">
                        <div class="summary-row final-total-summary">
                            <span>{{ t.finalTotal }}:</span>
                            <span id="final-cost" class="summary-value-final">--</span>
                        </div>
                    </div>
                </div>

                <div class="contact-form-container">
                    <form class="theme-form form-centered" [formGroup]="contactForm">
                        <h3 class="form-title">{{ t.contactUs }}</h3>
                        <div class="form-group">
                            <div class="row">
                                <div class="col-12 col-md-6 mb-3">
                                    <input type="text" name="name" formControlName="name" class="futuristic-input"
                                        autocomplete="off" [placeholder]="t.placeholderName" required maxlength="50">
                                </div>
                                <div class="col-12 col-md-6 mb-3">
                                    <input type="mobile" name="phone" formControlName="phone" class="futuristic-input"
                                        autocomplete="off" [placeholder]="t.placeholderPhone" SoloNumeros maxlength="11"
                                        minlength="9" required>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="row">
                                <div class="col-12 col-md-6 mb-3">
                                    <input type="email" formControlName="email" class="futuristic-input"
                                        [placeholder]="t.placeholderEmail" />
                                    <div *ngIf="contactForm.get('email')?.invalid && contactForm.get('email')?.touched"
                                        class="text-danger">
                                        {{ t.errorEmail }}
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 mb-3 d-flex align-items-end justify-content-center">
                                    <button (click)="sendEmailQuote()" class="button-primary"
                                        [disabled]="contactForm.invalid">
                                        <span>📧 {{ t.sendQuote }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

                <div class="external-links">
                    <p>{{ t.officialCalcLink }}</p>
                    <p><a href="https://azure.microsoft.com/es-es/pricing/calculator/" target="_blank" class="link">{{
                            t.calcAzure }}</a></p>
                    <p><a href="https://calculator.aws/" target="_blank" class="link">{{ t.calcAws }}</a></p>
                    <p class="disclaimer">{{ t.calcDisclaimer }}</p>
                </div>
            </div>
        </div>

        <div id="about" class="tab-content" [hidden]="activeTab !== 'about'">
            <div class="glass-panel">
                <h2 class="section-title">{{ t.aboutTitle }} <span>NGCloud</span></h2>

                <div class="module-section">
                    <p class="module-text">{{ t.aboutWhoWeAre }}</p>

                    <div class="container">
                        <div class="row sm-mb">
                            <div class="col-md-10"></div>
                        </div>
                        <div class="row sm-mb">
                            <div class="col-md-5">
                                <ul class="about-style">
                                    <li class="abt-hover">
                                        <div class="about-icon">
                                            <!-- Icono Misión: Cohete -->
                                            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M12 2.5C11.8 2.5 11.6 2.6 11.5 2.7L2 14L4 16H8L12 22L16 16H20L22 14L12.5 2.7C12.4 2.6 12.2 2.5 12 2.5ZM12 5.5C13.1 5.5 14 6.4 14 7.5C14 8.6 13.1 9.5 12 9.5C10.9 9.5 10 8.6 10 7.5C10 6.4 10.9 5.5 12 5.5Z" />
                                            </svg>
                                        </div>
                                        <div class="about-text">
                                            <h3 class="module-title">{{ t.aboutMissionTitle }}</h3>
                                            <p class="module-text">{{ t.aboutMissionDesc }}</p>
                                        </div>

                                    </li>
                                    <li class="abt-hover">
                                        <div class="about-icon">
                                            <!-- Icono Visión: Ojo/Futuro -->
                                            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 11 19.5C11.34 19.5 11.67 19.48 12 19.45C12.33 19.48 12.66 19.5 13 19.5C18 19.5 22.27 16.39 24 12C22.27 7.61 18 4.5 13 4.5C12.66 4.5 12.33 4.52 12 4.55C11.67 4.52 11.34 4.5 11 4.5H12ZM12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z" />
                                            </svg>
                                        </div>
                                        <div class="about-text">
                                            <h3 class="module-title">{{ t.aboutVisionTitle }}</h3>
                                            <p class="module-text">{{ t.aboutVisionDesc }}</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-md-5">
                                <ul class="about-style">
                                    <li class="abt-hover">
                                        <div class="about-icon">
                                            <!-- Icono Tecnología: Red/Atom -->
                                            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M15,9A2,2 0 0,1 17,11A2,2 0 0,1 15,13A2,2 0 0,1 13,11A2,2 0 0,1 15,9M15,5C17.5,5 19.66,6.46 20.61,8.59L23,7.93L23.63,10.23L21.29,10.88C21.37,11.23 21.37,11.61 21.29,11.96L23.63,12.6L23,14.9L20.61,14.25C19.66,16.38 17.5,17.84 15,17.84C14.31,17.84 13.65,17.7 13.04,17.44L11.5,21.5L9.63,20.8L11.08,16.94C9.69,16.14 8.61,14.79 8.16,13.2L3,13.2V10.8H8.16C8.61,9.21 9.69,7.86 11.08,7.06L9.63,3.2L11.5,2.5L13.04,6.56C13.65,6.3 14.31,6.16 15,6.16V5H15M15,7A4,4 0 0,0 11,11A4,4 0 0,0 15,15A4,4 0 0,0 19,11A4,4 0 0,0 15,7Z" />
                                            </svg>
                                        </div>
                                        <div class="about-text">
                                            <h3 class="module-title">{{ t.aboutTechTitle }}</h3>
                                            <ul>
                                                <li><strong>{{ t.aboutTechListTitle1 }}</strong> {{ t.aboutTechListDesc1
                                                    }}</li>
                                                <li><strong>{{ t.aboutTechListTitle2 }}</strong> {{ t.aboutTechListDesc2
                                                    }}</li>
                                                <li><strong>{{ t.aboutTechListTitle3 }}</strong> {{ t.aboutTechListDesc3
                                                    }}</li>
                                                <li><strong>{{ t.aboutTechListTitle4 }}</strong> {{ t.aboutTechListDesc4
                                                    }}</li>
                                            </ul>

                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
<app-loader [show]="sendEmail"></app-loader>